import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { formDataAppend } from "../../Utils/helpers";
import { Spin } from "antd";

import CustomStackedChart from "../Highcharts/CustomStackChart";
import BoxesMetrics from "./BoxesMetrics";
import { getColumnLineBoxData } from "../../Redux/Actions/Thunk/ColumnLineThunk";

function MultiStackChartBox(props) {
  const {
    columnLineData: {
      columnLineBoxData: {
        [props?.block?.block_id]: { chart_data: chartData = [] } = {},
      },
      isLoading,
    } = {},
  } = useSelector((state) => state);
  console.log(chartData);

  const dispatch = useDispatch();

  useEffect(() => {
    var data = props?.all_input_data;
    var formData = formDataAppend(data);
    if (props?.length == 0) {
      dispatch(getColumnLineBoxData(formData, props));
    }
  }, []);
  /*for filter data*/
  const [filter, setFilter] = useState("");
  const { filterData } = props;

  useEffect(() => {
    var data = props?.all_input_data;
    var formData = formDataAppend(data);
    dispatch(getColumnLineBoxData(formData, props));
  }, [filterData]);

  return (
    <>
      <Spin spinning={isLoading}>
        <div className="container">
          {chartData?.map((item, index) => (
            <div className="card" key={index}>
              <div className="card-shadow"></div>
              <div className="Box-wrapper">
                <BoxesMetrics metrics={item?.metrics} />
              </div>
              <div>
                <CustomStackedChart chartData={item?.chartData} />
              </div>
            </div>
          ))}
        </div>
      </Spin>
    </>
  );
}

export default MultiStackChartBox;
